import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 3h16c.55 0 1 .45 1 1s-.45 1-1 1H4c-.55 0-1-.45-1-1s.45-1 1-1z"
}), 'MaximizeRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MaximizeRounded.js
// module id = 4788
// module chunks = 2